import * as React from "react";
import AppBar from "@mui/material/AppBar";
import Box from "@mui/material/Box";
import CssBaseline from "@mui/material/CssBaseline";
import Drawer from "@mui/material/Drawer";
import IconButton from "@mui/material/IconButton";
import LogoutIcon from "@mui/icons-material/Logout";
import List from "@mui/material/List";
import ListItem from "@mui/material/ListItem";
import ListItemButton from "@mui/material/ListItemButton";
import ListItemIcon from "@mui/material/ListItemIcon";
import ListItemText from "@mui/material/ListItemText";
import MenuIcon from "@mui/icons-material/Menu";
import Toolbar from "@mui/material/Toolbar";
import Typography from "@mui/material/Typography";
import {
  GridToolbarColumnsButton,
  GridToolbarContainer,
  GridToolbarDensitySelector,
  GridToolbarFilterButton,
} from "@mui/x-data-grid";
import { Link } from "react-router-dom";
import { Grid, Skeleton, styled } from "@mui/material";
import { eraseCookie } from "../../utils/cookies";
import UserState from "../../recoil/UserState";
import { useResetRecoilState } from "recoil";
import FotoProfileState from "../../recoil/FotoProfileState";
import ProfileState from "../../recoil/ProfileState";

const drawerWidth = 250;

const ClearLink = styled(Link)({
  color: "inherit",
  textDecoration: "none",
  textTransform: "none",
});

export const GridSkeleton = styled(Grid)(({ theme }) => ({
  paddingLeft: "3vw",
  paddingTop: "1vh",
  [theme.breakpoints.down("sm")]: {
    paddingLeft: "0",
  },
}));

export const SkeletonText = styled(Skeleton)(({ theme }) => ({
  width: "40vw",
  height: "10vh",
  [theme.breakpoints.down("sm")]: {
    width: "45vw",
    height: "10vh",
  },
}));

export const SkeletonTable = styled(Skeleton)(({ theme }) => ({
  width: "75vw",
  height: "50vh",
  borderRadius: "20px",
  [theme.breakpoints.down("sm")]: {
    width: "85vw",
    height: "50vh",
  },
}));

export const SkeletonButton = styled(Skeleton)(({ theme }) => ({
  marginTop: "2vh",
  marginLeft: "65vw",
  width: "10vw",
  height: "5vh",
  borderRadius: "20px",
  [theme.breakpoints.down("sm")]: {
    marginLeft: "55vw",
    width: "30vw",
    height: "6vh",
  },
}));

export function CustomToolbar() {
  return (
    <GridToolbarContainer>
      <GridToolbarColumnsButton placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined} />
      <GridToolbarFilterButton placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined} />
      <GridToolbarDensitySelector placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined} />
    </GridToolbarContainer>
  );
}

export default function HeaderHR() {
  const [mobileOpen, setMobileOpen] = React.useState(false);

  const handleDrawerToggle = () => {
    setMobileOpen(!mobileOpen);
  };

  const removeRecoil = useResetRecoilState(UserState);
  const removeRecoilFoto = useResetRecoilState(FotoProfileState);
  const removeRecoilProfile = useResetRecoilState(ProfileState);

  const eraseAuthCookie = async () => {
    removeRecoilFoto();
    removeRecoilProfile();
    removeRecoil();
    eraseCookie("token");
  };
  const handleLogoutButton = () => {
    eraseAuthCookie().then(() => {
      window.location.reload();
    });
  };

  const drawer = (
    <div>
      <Toolbar />
      <Toolbar>
        <Box
          component="img"
          src={`${process.env.PUBLIC_URL}/images/LogoIndomobilCareer.png`}
          alt="IndomobilCareerLogo"
          sx={{
            width: "auto",
            height: "10vh",
            paddingTop: "2px",
            paddingBottom: "2px",
          }}
        />
      </Toolbar>
      <List>
        {[
          "Kandidat",
          "Interview",
          "TalentPool",
          "Job",
          "Pertanyaan",
          "Pendidikan",
          "Divisi",
        ].map((text, key) => (
          <ClearLink to={`/${text}`} key={key}>
            <ListItem key={text} disablePadding>
              <ListItemButton>
                <ListItemText>
                  <Typography
                    sx={{
                      fontWeight: window.location.href.includes(text)
                        ? "bold"
                        : "normal",
                      paddingLeft: "10px",
                    }}
                  >
                    {text === "TalentPool" ? "Talent Pool" : text}
                  </Typography>
                </ListItemText>
              </ListItemButton>
            </ListItem>
          </ClearLink>
        ))}
        <ListItem
          color="error"
          key={"Logout"}
          disablePadding
          onClick={handleLogoutButton}
          sx={{
            paddingLeft: "9px",
          }}
        >
          <ListItemButton>
            <ListItemIcon>
              <LogoutIcon color="error" />
            </ListItemIcon>
            <ListItemText>
              <Typography color="error">Logout</Typography>
            </ListItemText>
          </ListItemButton>
        </ListItem>
      </List>
    </div>
  );

  return (
    <>
      <CssBaseline />
      <AppBar
        position="fixed"
        sx={{
          width: { sm: `calc(100% - ${drawerWidth}px)` },
          ml: { sm: `${drawerWidth}px` },
        }}
      >
        <Toolbar>
          <IconButton
            color="inherit"
            edge="start"
            onClick={handleDrawerToggle}
            sx={{ mr: 2, display: { sm: "none" } }}
          >
            <MenuIcon />
          </IconButton>
          <Typography variant="h6" noWrap component="div">
            Indomobil Career HR
          </Typography>
        </Toolbar>
      </AppBar>
      <Box
        component="nav"
        sx={{ width: { sm: drawerWidth }, flexShrink: { sm: 0 } }}
      >
        {/* The implementation can be swapped with js to avoid SEO duplication of links. */}
        <Drawer
          variant="temporary"
          open={mobileOpen}
          onClose={handleDrawerToggle}
          ModalProps={{
            keepMounted: true, // Better open performance on mobile.
          }}
          sx={{
            display: { xs: "block", sm: "none" },
            "& .MuiDrawer-paper": {
              boxSizing: "border-box",
              width: drawerWidth,
            },
          }}
        >
          {drawer}
        </Drawer>
        <Drawer
          variant="permanent"
          sx={{
            display: { xs: "none", sm: "block" },
            "& .MuiDrawer-paper": {
              boxSizing: "border-box",
              width: drawerWidth,
            },
          }}
          open
        >
          {drawer}
        </Drawer>
      </Box>
    </>
  );
}
